import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type LearningMode = 'general' | 'pal';

export interface IPalState {
  learningMode: LearningMode;
  externalStudentId?: string;
  moduleRedirectionPath?: string;
  streak?: {
    session_id?: string;
    concept_id?: string;
    practice?: number;
    challenge?: number;
  };
  question_count?: {
    session_id?: string;
    concept_id?: string;
    practice?: number;
    challenge?: number;
    warmup?: number;
  };
}

const initialState: IPalState = {
  learningMode: 'general',
  externalStudentId: undefined,
};

export const palSlice = createSlice({
  name: 'pal',
  initialState,
  reducers: {
    resetPalState: (state) => {
      return initialState;
    },
    setLearningMode: (state, action: PayloadAction<LearningMode>) => {
      state.learningMode = action.payload;
    },
    setExternalStudentId: (state, action: PayloadAction<string>) => {
      state.externalStudentId = action.payload;
    },
    setModuleRedirectionPath: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.moduleRedirectionPath = action.payload;
    },
    setStreak: (
      state,
      action: PayloadAction<{
        session_id?: string;
        concept_id?: string;
        practice?: number;
        challenge?: number;
      }>
    ) => {
      state.streak = action.payload;
    },
    setQuestionCount: (
      state,
      action: PayloadAction<{
        session_id?: string;
        concept_id?: string;
        practice?: number;
        challenge?: number;
        warmup?: number;
      }>
    ) => {
      state.question_count = action.payload;
    },
  },
});

export const {
  resetPalState,
  setLearningMode,
  setExternalStudentId,
  setStreak,
  setQuestionCount,
  setModuleRedirectionPath,
} = palSlice.actions;
export default palSlice.reducer;
